document.addEventListener("DOMContentLoaded", function () {
    function setupMegaMenu(containerSelector) {
        const container = document.querySelector(containerSelector);
        if (!container) return;

        const buttons = container.querySelectorAll(".tab-btn");
        const tabs = container.querySelectorAll(".mega-menu__tabs-right");

        if (buttons.length === 0 || tabs.length === 0) return;


        buttons.forEach(button => {
            button.addEventListener("click", function () {
                // Remove active class from all buttons
                buttons.forEach(btn => btn.classList.remove("active"));
                this.classList.add("active");

                // Hide all tab content
                tabs.forEach(tab => tab.classList.remove("active"));

                // Show the selected tab content
                const target = this.getAttribute("data-target");
                const targetTab = document.getElementById(target);
                if (targetTab) {
                    targetTab.classList.add("active");
                }
            });
        });

        // Set first tab as active by default
        if (buttons.length > 0 && tabs.length > 0) {
            buttons[0].classList.add("active");
            tabs[0].classList.add("active");
        }
    }

    // Call function on mega menu
    setupMegaMenu(".mega-menu__tabs");

    function setupBackgroundWrap() {

        // Background wrap section
        const startMarker = document.querySelector('[data-background-wrap-start]');
        const endMarker = document.querySelector('[data-background-wrap-end]');

        
        if (!startMarker || !endMarker) return;
        
        const startSection = startMarker.closest('.shopify-section');
        const endSection = endMarker.closest('.shopify-section');
        
        if (!startSection || !endSection) return;
        
        // Create the wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'background-wrap';

        // Add custom class if provided
        const customClass = startMarker.dataset.customClass;
        if (customClass) wrapper.classList.add(customClass);

        // Optionally apply background styles
        const bgImage = startMarker.dataset.backgroundImage;
        const bgColor = startMarker.dataset.backgroundColor;

        if (bgImage) wrapper.style.backgroundImage = `url(${bgImage})`;
        if (bgColor) wrapper.style.backgroundColor = bgColor;

        // Insert wrapper before the startSection
        startSection.parentNode.insertBefore(wrapper, startSection);

        // Move all elements from startSection to endSection into the wrapper
        let current = startSection;
        while (current) {
            const next = current.nextElementSibling;
            wrapper.appendChild(current);
            if (current === endSection) break;
            current = next;
        }

    }
    setupBackgroundWrap();

});
